export default "__VITE_ASSET__235064e5__"